import { Box, Card, CardContent, Container, Grid, Skeleton } from "@mui/material";
import { styled } from "@mui/styles";

const MainCard = styled(Card)({
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  border: "1px solid #e5e7eb",
})

export default function CommonSearchPaginateSkeleton({
  isColumnFilter = false,
  loading = false
}) {

  if (!loading) return <></>;

  return (
    <MainCard sx={{ mb: 3 }}>
      <CardContent sx={{ display: "flex", p: 3, flexDirection: isColumnFilter ? "column" : "row", gap: 3, alignItems: isColumnFilter ? "flex-start" : "center" }}>
        {isColumnFilter && <Skeleton variant="text" width="35%" height={24} animation="wave" />}

        <Box sx={{ display: "flex", width: "100%", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
          <Skeleton variant="rounded" height={45} animation="wave" sx={{ display: "flex", flex: 3, borderRadius: "8px" }} />
          <Skeleton variant="rounded" height={45} animation="wave" sx={{ display: "flex", flex: 1, borderRadius: "8px" }} />
          <Skeleton variant="rounded" height={45} animation="wave" sx={{ display: "flex", flex: 1, borderRadius: "8px" }} />
          <Skeleton variant="rounded" height={45} animation="wave" sx={{ display: "flex", flex: 1.5, borderRadius: "8px" }} />
          <Skeleton variant="rounded" height={45} animation="wave" sx={{ display: "flex", flex: 1, borderRadius: "8px" }} />
          <Skeleton variant="rounded" height={45} animation="wave" sx={{ display: "flex", flex: 1, borderRadius: "8px" }} />
        </Box>
      </CardContent>
    </MainCard>
  )
}